import { redirect, useNavigate } from "react-router-dom";
import "./company-onboard.scss";
import { ChangeEvent, useContext, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks/typed-hooks";
import {
  companyRegistrationSelector,
  registerCompanyInfo,
} from "../../../redux/reducers/company-registration/companyRegistrationSlice";
import { SignupContext } from "../../providers/signupProvider";
import { toast } from "react-toastify";
import Form from "react-bootstrap/Form";
import { post } from "../../../common/services/api-service";
import {
  ICompanyInsightInfo,
  companyInsightSelector,
  updateCompanyInsight,
} from "../../../redux/reducers/company-insight/companyInsightSlice";
import {
  companyOnboardWizardSelector,
  nextStep,
  previousStep,
  setAnswer,
  setStep,
  setQuestions,
} from "../../../redux/reducers/company-onboard/companyOnboardSlice";
import { AppDispatch, RootState } from "../../../redux/store/store";
import { useDispatch, useSelector } from "react-redux";
import React from "react";
import {
  IOnboardQuestion,
  OnbarodQuestionType,
  OnboardAnswerOptionType,
} from "../../../redux/data/onboardingQuestions";
import { Col, Row, ToastHeader } from "react-bootstrap";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import axios from "axios";
import {
  IUserSessionInfo,
  updateUserSession,
  userSessionStateSelector,
} from "../../../redux/reducers/user-session/userSessionSlice";
import LoadingOverlay from "../../../components/loading/LoadingOverlay"; // Import the LoadingOverlay component

const CompanyOnboard: React.FC = () => {
  let apiUrlBase = process.env.REACT_APP_API_URL || "https://trowelwa01.azurewebsites.net/api/";
  if (!apiUrlBase.endsWith('/')) {
    apiUrlBase += '/';
  }

  const [hasFinished, setHasFinished] = useState<boolean>(false);
  const [slideDirection, setSlideDirection] = useState<string>("forward");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [waitOverlayText, setWaitOverlayText] = useState<string>(
    "Processing, please wait..."
  );
  const [hasDynamicQuestionsGenerated, setHasDynamicQuestionsGenerated] =
    useState<boolean>(false);

  const [userSessionInfo, setUserSessionInfo] =
    useState<IUserSessionInfo | null>(null);

  const dispatch: AppDispatch = useDispatch();
  const currentStep = useSelector(
    (state: RootState) => state.companyOnboardWizardReducer.currentStep
  );
  const answers = useSelector(
    (state: RootState) => state.companyOnboardWizardReducer.answers
  );
  const questions = useSelector(
    (state: RootState) => state.companyOnboardWizardReducer.questions
  );

  const selectCompnayOnboardWizard = useAppSelector(
    companyOnboardWizardSelector
  );

  const userSessionState = useAppSelector(userSessionStateSelector);
  //const selectUserSessionInfo = useAppSelector(userSessionStateSelector);
  const navigate = useNavigate();

  useEffect(() => {
    console.log("User State info", userSessionState);

    setUserSessionInfo(userSessionState);

    console.log(
      "Questions in the state ",
      questions,
      selectCompnayOnboardWizard.questions
    );
    if (!questions || !questions.length) {
      setIsLoading(true);
      // Make api call to get the onboarding question list
      let getOnboardingQuestions = `${apiUrlBase}onboarding/question/list`;

      axios
        .get(getOnboardingQuestions)
        .then((response: any) => {
          console.log("onboarding questions ", response);
          const questions = response?.data;
          dispatch(setQuestions(questions));
          setIsLoading(false);
        })
        .catch((err: any) => {
          console.log("Error response from the service ", err);
          let { detail } = err?.response?.data;
          toast.error("Error while reading onboarding questions " + detail);
          setIsLoading(false);
        });
    }
  }, [userSessionState]);

  // useEffect(() => {
  //   if (questions && questions.length > 0) {
  //     setIsLoading(false);
  //   } else if (questions && questions.length === 0) {
  //     setIsLoading(false); // No questions, but loading is done
  //   }
  // }, [questions]);
  //const dispatch = useAppDispatch();

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
    optionValue?: string
  ) => {
    const currentAnswers = answers || {};
    // const value = optionValue
    //   ? [...((currentAnswers[currentStep] as string[]) || []), optionValue]
    //   : e.target.value;

    // check the current answer is type of string or string array

    if (optionValue) {
      // If optionValue is provided, it means we are dealing with a multiple choice question
      let activeAnswers: any = (currentAnswers[currentStep] as string[]) || [];
      if (activeAnswers && activeAnswers.includes(optionValue)) {
        // If the value already exists, remove it from the array
        let updatedAnswers = activeAnswers.filter(
          (item: any) => item != optionValue
        );
        dispatch(setAnswer({ step: currentStep, answer: updatedAnswers }));
      } else {
        dispatch(
          setAnswer({
            step: currentStep,
            answer: [...activeAnswers, e.target.value],
          })
        );
      }
    } else {
      dispatch(setAnswer({ step: currentStep, answer: e.target.value }));
    }
  };

  const handleNext = () => {
    setSlideDirection("forward");
    dispatch(nextStep());
  };

  const handlePrevious = () => {
    setSlideDirection("reverse");
    dispatch(previousStep());
  };

  const generateDynamicQuestions = (firmId: string) => {
    setIsLoading(true);
    setWaitOverlayText(
      "Analyzing your responses to craft the next set of questions just for you…"
    );
    //Send request to the below service
    // http://localhost:8000/api/agents/questions/<firmId>/<randomGuid>
    // https://trowelwa01.azurewebsites.net/api/agents/questions/<firmId>/<randomGuid>
    const userId = sessionStorage.getItem("user_id");
    console.log("User ID from session: ", userId);
    if (userId == "") {
      toast.warn("Your session has expired, please login again."); //todo: need to redirect to the login page
      setIsLoading(false);
      return;
    }
    // Generate a random GUID
    const randomGuid = crypto.randomUUID();
    console.log("Random GUID: ", randomGuid);
    // Construct the API URL
    console.log("Firm ID: ", firmId); // Log the firmId for debugging
    // with actual firmId if available
    const dynamicQuestionGenUrl = `${apiUrlBase}agents/questions/${firmId}/${randomGuid}`;
    console.log("API URL: ", dynamicQuestionGenUrl); // Log the API URL for debugging
    axios
      .get(dynamicQuestionGenUrl)
      .then((response: any) => {
        setIsLoading(false);
        console.log("Dynamic questions response: ", response);
        /*
        response.data = [
    {
        "fieldName": "strategicGoal",
        "question": "What is the primary strategic goal for The Ambrosia over the next 12 months?",
        "type": "single-choice",
        "options": [
            {
                "value": "Expand physical presence by opening new locations",
                "type": "option"
            },
            {
                "value": "Increase online sales and delivery services",
                "type": "option"
            },
            {
                "value": "Diversify product offerings",
                "type": "option"
            },
            {
                "value": "Enhance brand recognition through marketing",
                "type": "option"
            }
        ]
    },
    {
        "fieldName": "customerFeedback",
        "question": "How does The Ambrosia currently collect and utilize customer feedback to improve its offerings?",
        "type": "multiple-choice",
        "options": [
            {
                "value": "In-store surveys",
                "type": "option"
            },
            {
                "value": "Online reviews monitoring",
                "type": "option"
            },
            {
                "value": "Direct feedback on website",
                "type": "option"
            },
            {
                "value": "Social media engagement",
                "type": "option"
            }
        ]
    },
    {
        "fieldName": "costControl",
        "question": "What are the biggest challenges The Ambrosia faces in terms of cost control and financial efficiency?",
        "type": "open-ended",
        "options": null
    }
]
        */
        const dynamicQuestions = response.data;
        if (dynamicQuestions && dynamicQuestions.length > 0) {
          /**
           * convert the json response to the IOnboardQuestion type
           * 
           * 
           * {
    id: 3,
    fieldName: "businessSize",
    type: OnbarodQuestionType.SINGLE,
    subQuestion:"What's your business size ?",
    question: "How many full-time team members are on your team?",
    options: [{value:"Just me and a few others (1-10)"}, {value:"A growing team (11-50)"}, {value:"A bustling team (51-250)"}, {value:"Larger team (251+)"}],
  }
           * 
           */
          let staticQuestionLength = questions.length;
          const convertedQuestions: IOnboardQuestion[] = dynamicQuestions.map(
            (q: any, index: number) => {
              return {
                id: index + staticQuestionLength, // Ensure unique ID
                fieldName: q.fieldName,
                type:
                  q.type === "single-choice"
                    ? OnbarodQuestionType.SINGLE
                    : q.type === "multiple-choice"
                    ? OnbarodQuestionType.MULTIPLE
                    : q.type === "multiline-text"
                    ? OnbarodQuestionType.MULTILINE_TEXT
                    : OnbarodQuestionType.TEXT,
                question: q.question,
                subQuestion: "",
                options: q.options?.map((option: any) => ({
                  value: option.value,
                  type: null, //option.type || OnboardAnswerOptionType.RADIO_BUTTON,
                })),
              };
            }
          );

          // Add the converted questions to the existing questions
          const updatedQuestions = [...questions, ...convertedQuestions];
          // Update the questions in the Redux store
          dispatch(setQuestions(updatedQuestions));

          // Set the flag to indicate that dynamic questions have been generated
          setHasDynamicQuestionsGenerated(true);
          console.log("Dynamic questions generated: ", updatedQuestions);
          // Move to the next step
          dispatch(nextStep());
        } else {
          toast.warn("No dynamic questions available at this time.");
        }
      })
      .catch((error: any) => {
        setIsLoading(false);
        console.error("Error fetching dynamic questions: ", error);
        toast.error(
          "Failed to fetch dynamic questions. Please try again later."
        );
      });
  };

  const submitUserAnswersForCompanyProfile = () => {
    // Step 1. Validate user inputs
    if (currentStep < questions.length - 1) {
      toast.warn("Please answer all the questions before finishing.");
      return;
    }
    // Step 2. Send a request to service to save the user inputs
    //const userId = sessionStorage.getItem("user_id");

    const userId = sessionStorage.getItem("user_id");
    if (!userId) {
      toast.warn("Your session has expired, please login again."); //todo: need to redirect to the login page
      return;
    }

    // let requestPayload = {
    //   responses: [] as { question: string; response: string }[],
    // }

    setIsLoading(true);
    setWaitOverlayText("Saving your answers, please wait…");
    try {
      let requestPayload = generateQuestionAnswerPayload(answers, questions);

      let firm_id = userSessionInfo?.firmId;
      if (!firm_id) {
        toast.warn("Your firm ID is not available, please try again later.");
        return;
      }

      submitAllUserQuestionnairAnswers(
        apiUrlBase,
        firm_id,
        requestPayload,
        userSessionInfo,
        setUserSessionInfo,
        setHasFinished,
        dispatch
      );
    } catch (error) {
      console.error("Error generating question answer payload: ", error);
      toast.error(
        "An error occurred while processing your answers. Please try again."
      );
      setIsLoading(false);
    }
  };

  const sendUserAnswersForDynamicQuestionGen = () => {
    // Step 1. Validate user inputs
    setIsLoading(true);
    setWaitOverlayText(
      "Processing your answers to create something meaningful…"
    );
    // Step 2. Send a request to service to save the user inputs
    const userId = sessionStorage.getItem("user_id");
    if (userId == "") {
      toast.warn("Your session has expired, please login again."); //todo: need to redirect to the login page
      setIsLoading(false);
      return;
    }

    let payload: Record<string, string> = {};
    if (answers && questions) {
      payload["userId"] = userId as string;
      questions.forEach((question: IOnboardQuestion, index: number) => {
        if (answers[index] != null && question.fieldName) {
          payload[question.fieldName] = answers[index] as string;
        }
      });
    }

    let updateAPIURL = `${apiUrlBase}data/company-profile`;
    //"https://trowelwa01.azurewebsites.net/data/company-profile";
    axios
      .post(updateAPIURL, payload)
      .then((response: any) => {
        setIsLoading(false);
        console.log("Status message from API ", response);
        /** Response.data = { firmId: "1548afa8-e81d-4e0c-8b67-97666d6beca8" } */

        // UPdate the firmId in the user session info
        const firmId = response.data.firmId;
        console.log("Firm ID from response: ", firmId);
        if (userSessionInfo) {
          const updatedUserSessionInfo: IUserSessionInfo = {
            ...userSessionInfo,
            firmId: firmId,
          };
          setUserSessionInfo(updatedUserSessionInfo);
          // dispatch(updateCompanyInsight(updatedUserSessionInfo));
        }

        // Update redux state with firmid
        dispatch(
          updateUserSession({
            ...userSessionState,
            firmId: firmId,
          })
        );

        generateDynamicQuestions(firmId);
        // Step 3. Display success messages
        // setHasFinished(true);
      })
      .catch((err: any) => {
        console.log("Error response from the service ", err);
        setIsLoading(false);
        let { detail } = err.response.data;
        if (detail.includes("Not authenticated")) {
          toast.error(`Onboarding failed, ${detail}. Please login again.`);
          redirect("/login");
          //SKD:Reset previous login state and session variable values
        } else
          toast.error(`Onboarding failed, ${detail}. Please try again later.`);

        // Step 3. Display success messages
        //setHasFinished(true);
      });

    //dispatch(previousStep());
  };

  const handleRefresh = () => {
    const storedStep = localStorage.getItem("currentStep");
    if (storedStep) {
      dispatch(setStep(Number(storedStep)));
    }
  };

  useEffect(() => {
    localStorage.setItem("currentStep", currentStep.toString());
  }, [currentStep]);

  useEffect(() => {
    handleRefresh();
  }, []);

  const handleOptionClick = (option: string) => {
    dispatch(setAnswer({ step: currentStep, answer: option }));
  };

  const onTextValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setAnswer({ step: currentStep, answer: event.target.value }));
  };

  const renderStepContent = () => {
    const currentQuestion = questions[currentStep];
    //if (!currentQuestion) return <div>No more questions</div>;
    // Check both currentQuestion and isLoading state before showing the no more questions message
    if (isLoading) {
      return <div>Loading questions...</div>;
    }

    if (!currentQuestion) {
      return <div>No more questions</div>;
    }
    const currentAnswers = answers || {};

    switch (currentQuestion.type) {
      case OnbarodQuestionType.TEXT:
        return (
          <div className="onboard-wizard-question-box text-question-box">
            <span className="sub-question-text">
              {currentQuestion.subQuestion}
            </span>
            <h2 className="question-text pd-t-b-sm">
              {currentQuestion.question}
            </h2>
            {/* <input
              className="answer-box-single"
              placeholder="Type Here"
              type="text"
              value={(currentAnswers[currentStep] as string) || ""}
              onChange={handleChange}
            /> */}

            <div className="row questions-options">
              <div className="col-sm-12">
                <div className="input-container">
                  <input
                    type="text"
                    className="main-input"
                    placeholder="Type Here"
                    value={(currentAnswers[currentStep] as string) || ""}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      case OnbarodQuestionType.MULTILINE_TEXT:
        return (
          <div className="onboard-wizard-question-box text-question-box">
            <span className="sub-question-text">
              {currentQuestion.subQuestion}
            </span>
            <h2 className="question-text pd-t-b-sm">
              {currentQuestion.question}
            </h2>
           {/* <span className="question-text">{currentQuestion.question}</span>
             <textarea
              className="answer-box-multiple"
              placeholder="Enter details"
              value={(currentAnswers[currentStep] as string) || ""}
              onChange={handleChange}
            /> */}
            <div className="row questions-options">
              <div className="col-sm-12">
                <textarea
                  className="custom-textarea"
                  placeholder="Enter details"
                  value={(currentAnswers[currentStep] as string) || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        );
      case OnbarodQuestionType.SINGLE:
        return (
          <div className="onboard-wizard-question-box single-question-box">
            <span className="sub-question-text">
              {currentQuestion.subQuestion}
            </span>

            <h2 className="question-text pd-t-b-sm">
              {currentQuestion.question}
            </h2>
            {/* <div className="question-text">{currentQuestion.question}</div> */}

            <div className="row questions-options">
              {currentQuestion.options!.map((option, idx) => (
                <div className="col-sm-6" key={option.value}>
                  <div className="custom-radio-card" onClick={() => handleOptionClick(option.value)}>
                   
                    {option.type === OnboardAnswerOptionType.RADIO_BUTTON || ( option.type == undefined && (
                      <>
                    <input
                      type="radio"
                      id={`option-${idx}`}
                      name={`question-${currentStep}`}
                      checked={(currentAnswers[currentStep] as string) === option.value}
                      onChange={() => handleOptionClick(option.value)}
                    />
                    <label htmlFor={`option-${idx}`}>{option.value}</label>
                   </> ))}
                    {option.type === OnboardAnswerOptionType.TEXT_BOX && (
                      <div className="input-container">
                        <input
                            type="text"
                            className="optional-input-box"
                            placeholder="Other (Please specify)"
                            onChange={onTextValueChange}
                            value={
                              currentQuestion.options?.filter(
                                (value) =>
                                  value.type !=
                                    OnboardAnswerOptionType.TEXT_BOX &&
                                  value.value == currentAnswers[currentStep]
                              ).length === 0
                                ? currentAnswers[currentStep]
                                : ""
                            }
                          />
                          {option.value}
                        </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
           
            
            {/* <select
              value={(currentAnswers[currentStep] as string) || ""}
              onChange={handleChange}
            >
              {currentQuestion.options!.map((option) => (
                <option key={option} value={option}>
                  {" "}
                  {option}{" "}
                </option>
              ))}
            </select> */}
          </div>
        );
      case OnbarodQuestionType.MULTIPLE:
        return (
          <div className="onboard-wizard-question-box multiple-question-box">
            <span className="sub-question-text">
              {currentQuestion.subQuestion}
            </span>
            {/* <h4 className="question-text">{currentQuestion.question}</h4> */}
             <h2 className="question-text pd-t-b-sm">
              {currentQuestion.question}
            </h2>
            <div className="row questions-options">
              {
              currentQuestion.options!.map((option, idx) => {

                const isTextBox = option.type === OnboardAnswerOptionType.TEXT_BOX;
                const selectedValues = (currentAnswers[currentStep] as string[]) || [];
                const isChecked = selectedValues.includes(option.value);

                 // For TEXT_BOX, store the value in a separate state or as the value in answers
                let textBoxValue = "";
                if (isTextBox) {
                  const allOptionValues = currentQuestion.options!.map((opt) => opt.value);
                  textBoxValue = selectedValues.find(
                      (val) => !allOptionValues.includes(val)
                    ) || "";
                }
                
                return(
                <div className="col-lg-6 col-sm-12" key={option.value}>
                  <div className="custom-checkbox-card" >
                   {!isTextBox ? (
                    <>
                      <input
                        type="checkbox"
                        id={`option-${idx}`}
                        checked={((currentAnswers[currentStep] as string[]) || []).includes(option.value)}
                        onChange={() => handleChange({target: {value: option.value}} as ChangeEvent<HTMLInputElement>, option.value)}
                      />
                      <label htmlFor={`option-${idx}`}>{option.value}</label>
                    </>  
                    ): (
                      <div className="input-container">
                        <input
                              type="text"
                              className="optional-input-box"
                              placeholder="Others (Please specify)"
                              value={textBoxValue}
                              onChange={(e) => {
                                const allOptionValues =
                                  currentQuestion.options!.map(
                                    (opt) => opt.value
                                  );
                                const filtered = selectedValues.filter((val) =>
                                  allOptionValues.includes(val)
                                );
                                const newValue = e.target.value;
                                const updated = newValue
                                  ? [...filtered, newValue]
                                  : filtered;
                                dispatch(
                                  setAnswer({
                                    step: currentStep,
                                    answer: updated,
                                  })
                                );
                              }}
                              onClick={(e) => e.stopPropagation()} // Prevent parent click
                        />
                      </div>
                    )}
                  </div>
                </div>
                 )

              })}
            </div>

            {/* <div className="row questions-options">
 
                {currentQuestion.options!.map((option, idx) => {
                  const isTextBox = option.type === OnboardAnswerOptionType.TEXT_BOX;
                  const selectedValues = (currentAnswers[currentStep] as string[]) || [];
                  const isChecked = selectedValues.includes(option.value);

                  // For TEXT_BOX, store the value in a separate state or as the value in answers
                  let textBoxValue = "";
                  if (isTextBox) {
                    const allOptionValues = currentQuestion.options!.map((opt) => opt.value);
                    textBoxValue = selectedValues.find(
                        (val) => !allOptionValues.includes(val)
                      ) || "";
                  }

                  return (
                    <div className="col-sm-6" key={option.value}>
                      <div className={`custom-checkbox-card ${
                          isChecked ? "--selected-item" : ""
                        }`}
                        style={{ cursor: isTextBox ? "default" : "pointer" }}
                        onClick={() => {
                          if (!isTextBox) {
                            handleChange(
                              {
                                target: { value: option.value },
                              } as ChangeEvent<HTMLInputElement>,
                              option.value
                            );
                          }
                        }}
                      >
                        {!isTextBox ? (
                          <>
                           <input
                      type="checkbox"
                      id={`option-${idx}`}
                      checked={isChecked}
                      onChange={() => handleChange({target: {value: option.value}} as ChangeEvent<HTMLInputElement>, option.value)}
                    />
                    <label htmlFor={`option-${idx}`}>{option.value}</label>
                            {/* <span
                              className={`custom-checkbox ${
                                isChecked ? "checked" : ""
                              }`}
                              aria-checked={isChecked}
                              tabIndex={-1}
                            />
                            <span>{option.value}</span> */}
                          {/* </>
                        ) : (
                          <input
                            type="text"
                            className="other-textbox"
                            placeholder="Others (Please specify)"
                            value={textBoxValue}
                            onChange={(e) => {
                              const allOptionValues =
                                currentQuestion.options!.map(
                                  (opt) => opt.value
                                );
                              const filtered = selectedValues.filter((val) =>
                                allOptionValues.includes(val)
                              );
                              const newValue = e.target.value;
                              const updated = newValue
                                ? [...filtered, newValue]
                                : filtered;
                              dispatch(
                                setAnswer({
                                  step: currentStep,
                                  answer: updated,
                                })
                              );
                            }}
                            onClick={(e) => e.stopPropagation()} // Prevent parent click
                          />
                        )}
                      </div>
                    </div>
                  );
                })}
     
            </div>  */} 
          </div>
        );
      default:
        return <div>Unknown question type</div>;
    }
  };

  function generateQuestionAnswerPayload(
    answers: Record<number, string | string[]> | undefined,
    questions: IOnboardQuestion[]
  ) {
    let requestPayload = {
      responses: [] as { question: string; response: string }[],
    };
    if (answers && questions) {
      questions.forEach((question: IOnboardQuestion, index: number) => {
        if (answers[index] != null && question.question) {
          requestPayload.responses.push({
            question: question.question,
            response: answers[index] as string,
          });
        }
      });
    }

    return requestPayload;
  }

  function submitAllUserQuestionnairAnswers(
    baseUrl: string | undefined,
    firm_id: string,
    requestPayload: { responses: { question: string; response: string }[] },
    userSessionInfo: IUserSessionInfo | null,
    setUserSessionInfo: React.Dispatch<
      React.SetStateAction<IUserSessionInfo | null>
    >,
    setHasFinished: React.Dispatch<React.SetStateAction<boolean>>,
    dispatch: any
  ) {
    let updateAPIURL = `${baseUrl}agents/questions/response/all/${firm_id}`;

    //"https://trowelwa01.azurewebsites.net/api/agents/questions/response/all/${firm_id}`;
    axios
      .post(updateAPIURL, requestPayload)
      .then((response: any) => {
        console.log("Status message from API ", response);
        /** Response.data = { firmId: "1548afa8-e81d-4e0c-8b67-97666d6beca8" } */
        if (!response.data || !response.data.length) {
          toast.error("Failed to retrieve firm ID from the response.");
          return;
        }

        // UPdate the firmId in the user session info
        const firmId = response.data[0].firmId;
        if (!firmId) {
          toast.error("Failed to retrieve firm ID from the response.");
          return;
        }
        console.log("Firm ID from response: ", firmId);
        if (userSessionInfo) {
          const updatedUserSessionInfo: IUserSessionInfo = {
            ...userSessionInfo,
            firmId: firmId,
          };
          setUserSessionInfo(updatedUserSessionInfo);
          // dispatch(updateCompanyInsight(updatedUserSessionInfo));
        }
        setHasFinished(true);

        // setTimeout(() => {
        //   navigate("/dashboard");
        //   setIsLoading(false);
        // }, 1500);
        // toast.success("Your answers have been submitted successfully!");

        console.log("Generating insights for firm ID: ", firmId);
        // Make a post request to generate insights
        initiateInsightGenerationProcess(baseUrl, firmId, dispatch);

        navigate("/dashboard");
        setIsLoading(false);
        toast.success("Your answers have been submitted successfully!");
      })
      .catch((err: any) => {
        console.log("Error response from the service ", err);
        toast.error(
          `Onboarding failed, ${err.message}. Please try again later.`
        );
        setIsLoading(false);
      });
  }

  function initiateInsightGenerationProcess(
    apiUrl: string | undefined,
    firmId: any,
    dispatch: any
  ) {
    setIsLoading(true);
    const generateInsightsUrl = `${apiUrl}agents/insights`;
    axios
      .post(generateInsightsUrl, {
        firmId: firmId,
        conversationId: "",
        userQuery: "",
      })
      .then((insightsResponse: any) => {
        console.log("Insights generated successfully: ", insightsResponse);

        let executionId = insightsResponse.data.executionId;
        console.log("Execution ID: ", executionId);
        // update the company insight executionId in the Redux store
        dispatch(updateCompanyInsight({ executionId: executionId }));
        setIsLoading(false);
      })
      .catch((insightsError: any) => {
        console.error("Error generating insights: ", insightsError);
        toast.error("Failed to generate insights. Please try again later.");
        setIsLoading(false);
      });
  }

  return (
    <>
      <LoadingOverlay isLoading={isLoading} loadingText={waitOverlayText} />

      <div className="container-fluid m-container">
        <div className="row justify-content-center">
          <div
            className="col-lg-6 col-md-8 justify-content-center"
            style={{ marginTop: 20 }}
          >
            <div className="text-center w-100 justify-content-center email-notification onboarding">
              <span className="progress-indicator">{currentStep + 1}</span>
              <span className="progress-separator"></span>
              <span className="progress-indicator">{questions.length}</span>
              {/* Render question/answer wizard */}
              <TransitionGroup>
                <CSSTransition
                  key={currentStep}
                  timeout={300}
                  classNames={
                    slideDirection === "forward" ? "slide" : "slide-reverse"
                  }
                >
                  {renderStepContent()}
                </CSSTransition>
              </TransitionGroup>
              <div className="nav-box">
                {currentStep > 0 && (
                  <button
                    className="btn btn-secondary btn-lg"
                    onClick={handlePrevious}
                  >
                    Back
                  </button>
                )}
                {currentStep < questions.length - 1 && (
                  <button className="btn btn-lg btn-main" onClick={handleNext}>
                    {currentStep === 0 ? "Get Started" : "Proceed"}
                  </button>
                )}
                {currentStep === questions.length - 1 &&
                  !hasDynamicQuestionsGenerated && (
                    <button
                      className="btn btn-lg btn-main"
                      onClick={sendUserAnswersForDynamicQuestionGen}
                    >
                      Proceed
                    </button>
                  )}
                {currentStep === questions.length - 1 &&
                  hasDynamicQuestionsGenerated && (
                    <button
                      className="btn btn-lg btn-main"
                      onClick={submitUserAnswersForCompanyProfile}
                    >
                      Finish
                    </button>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="circle-bg circle1"></div>
      <div className="banner-container">
        <div className="gr-overlay radial-gradient-position"></div>
        <div className="gr-overlay radial-gradient-position3"></div>
        <div className="gr-overlay radial-gradient-position2"></div>
      </div>
      {hasFinished && (
        <div className="onboard-wizard-finished">
          <div className="finish-wrapper">
            <div className="finish-wrapper__image"></div>
            <div className="finish-wrapper__sub-text-bold">
              Congratulations on completing the onboarding process!
            </div>
            <div className="finish-wrapper__sub-text">
              You're now ready to explore your personalized dashboard. Here, you
              can access all your features, track progress, and stay updated.
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CompanyOnboard;
